import { useCallback, useMemo } from 'react';
import { useMutation } from '@apollo/client/react';
import { PUBLISH } from '../graphql/operations';
import useApi from './useApi';

export function usePublish() {
  const [publish, { loading, error }] = useMutation(PUBLISH);

  const execute = async () => {
    const { data } = await publish();
    return data.publish;
  };

  return { execute, loading, error };
}

// Legacy default export with REST API fallback for backward compatibility
export default function usePublishRest() {
  const api = useApi();

  const publish = useCallback(() => api.post('/publish', {}), [api]);

  return useMemo(
    () => ({
      publish,
    }),
    [publish],
  );
}
